import { render } from "./Authorize.vue?vue&type=template&id=3685cb7e&scoped=true&ts=true"
import script from "./Authorize.vue?vue&type=script&lang=ts"
export * from "./Authorize.vue?vue&type=script&lang=ts"

import "./Authorize.vue?vue&type=style&index=0&id=3685cb7e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3685cb7e"]])

export default __exports__